import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};
var iniActivity;
//var iniLocation;
//var iniCampaign;

class ActivityFeatureEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);
        
        var data = props.Daatta.filter(function (d) {
            return d.activityFeatureId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            ActivityFeatureId: data[0].activityFeatureId,
            Activity_Id: data[0].activity_Id,
            ContentType: data[0].contentType,
            VideoLength: data[0].videoLength,
            PublishWeekDay: data[0].publishWeekDay,
            PublishTimeOfDay: data[0].publishTimeOfDay,
            NumOfFemale: data[0].numOfFemale,
            NumOfMale: data[0].numOfMale,
            NumOfAnimal: data[0].numOfAnimal,
            Location: data[0].location,
            HasText: data[0].hasText,
            HasMusic: data[0].hasMusic,
            Setup: data[0].setup,
            BaseOnTrend: data[0].baseOnTrend,
            NumOfHastags: data[0].numOfHastags,
            NumOfTags: data[0].numOfTags,
            BrandShowLengthSec: data[0].brandShowLengthSec,
            BrandShowPosition: data[0].brandShowPosition,
            IsPitching: data[0].isPitching,
            IsStrongCTA: data[0].isStrongCTA,
            IsGeneralInsight: data[0].isGeneralInsight,
            Modifier: data[0].modifier,
            StartTime: data[0].startTime,
            EndTime: data[0].endTime,
            activity: (Object.keys(props.lookupLists.activity).map((d) => ({ value: d, label: props.lookupLists.activity[d] })) || []),
            
        };

    }

    UNSAFE_componentWillMount() {
        iniActivity = this.state.activity.find(({ value }) => value === (this.state.Activity_Id || '').toString());
        
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            ActivityFeatureId: this.state.data[0].activityFeatureId,
            Activity_Id: this.state.data[0].activity_Id,
            ContentType: this.state.data[0].contentType,
            VideoLength: this.state.data[0].videoLength,
            PublishWeekDay: this.state.data[0].publishWeekDay,
            PublishTimeOfDay: this.state.data[0].publishTimeOfDay,
            NumOfFemale: this.state.data[0].numOfFemale,
            NumOfMale: this.state.data[0].numOfMale,
            NumOfAnimal: this.state.data[0].numOfAnimal,
            Location: this.state.data[0].location,
            HasText: this.state.data[0].hasText,
            HasMusic: this.state.data[0].hasMusic,
            Setup: this.state.data[0].setup,
            BaseOnTrend: this.state.data[0].baseOnTrend,
            NumOfHastags: this.state.data[0].numOfHastags,
            NumOfTags: this.state.data[0].numOfTags,
            BrandShowLengthSec: this.state.data[0].brandShowLengthSec,
            BrandShowPosition: this.state.data[0].brandShowPosition,
            IsPitching: this.state.data[0].isPitching,
            IsStrongCTA: this.state.data[0].isStrongCTA,
            IsGeneralInsight: this.state.data[0].isGeneralInsight,
            Modifier: this.state.data[0].modifier,
            StartTime: this.state.data[0].startTime,
            EndTime: this.state.data[0].endTime
            
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            ActivityFeatureId: this.state.ActivityFeatureId,
            Activity_Id: this.state.Activity_Id,
            ContentType: this.state.ContentType,
            VideoLength: this.state.VideoLength,
            PublishWeekDay: this.state.PublishWeekDay,
            PublishTimeOfDay: this.state.PublishTimeOfDay,
            NumOfFemale: this.state.NumOfFemale,
            NumOfMale: this.state.NumOfMale,
            NumOfAnimal: this.state.NumOfAnimal,
            Location: this.state.Location,
            HasText: this.state.HasText,
            HasMusic: this.state.HasMusic,
            Setup: this.state.Setup,
            BaseOnTrend: this.state.BaseOnTrend,
            NumOfHastags: this.state.NumOfHastags,
            NumOfTags: this.state.NumOfTags,
            BrandShowLengthSec: this.state.BrandShowLengthSec,
            BrandShowPosition: this.state.BrandShowPosition,
            IsPitching: this.state.IsPitching,
            IsStrongCTA: this.state.IsStrongCTA,
            IsGeneralInsight: this.state.IsGeneralInsight,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime

        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, activity } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.ActivityFeature.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniActivity}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Activity_Id')}
                                options={activity}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.ActivityFeature.Columns[1]} />}
                            />
                        </Box>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.ContentType}
                            onChange={this.handleChange('ContentType')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.VideoLength}
                            onChange={this.handleChange('VideoLength')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.PublishWeekDay}
                            onChange={this.handleChange('PublishWeekDay')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.PublishTimeOfDay}
                            onChange={this.handleChange('PublishTimeOfDay')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.NumOfFemale}
                            onChange={this.handleChange('NumOfFemale')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.NumOfMale}
                            onChange={this.handleChange('NumOfMale')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[8]}
                            type="text"
                            fullWidth
                            value={this.state.NumOfAnimal}
                            onChange={this.handleChange('NumOfAnimal')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[9]}
                            type="text"
                            fullWidth
                            value={this.state.Location}
                            onChange={this.handleChange('Location')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[10]}
                            type="text"
                            fullWidth
                            value={this.state.HasText}
                            onChange={this.handleChange('HasText')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[11]}
                            type="text"
                            fullWidth
                            value={this.state.HasMusic}
                            onChange={this.handleChange('HasMusic')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[12]}
                            type="text"
                            fullWidth
                            value={this.state.Setup}
                            onChange={this.handleChange('Setup')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[13]}
                            type="text"
                            fullWidth
                            value={this.state.BaseOnTrend}
                            onChange={this.handleChange('BaseOnTrend')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[14]}
                            type="text"
                            fullWidth
                            value={this.state.NumOfHastags}
                            onChange={this.handleChange('NumOfHastags')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[15]}
                            type="text"
                            fullWidth
                            value={this.state.NumOfTags}
                            onChange={this.handleChange('NumOfTags')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[16]}
                            type="text"
                            fullWidth
                            value={this.state.BrandShowLengthSec}
                            onChange={this.handleChange('BrandShowLengthSec')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[17]}
                            type="text"
                            fullWidth
                            value={this.state.BrandShowPosition}
                            onChange={this.handleChange('BrandShowPosition')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[18]}
                            type="text"
                            fullWidth
                            value={this.state.IsPitching}
                            onChange={this.handleChange('IsPitching')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[19]}
                            type="text"
                            fullWidth
                            value={this.state.IsStrongCTA}
                            onChange={this.handleChange('IsStrongCTA')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[20]}
                            type="text"
                            fullWidth
                            value={this.state.IsGeneralInsight}
                            onChange={this.handleChange('IsGeneralInsight')}
                        />
                      
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />

            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "ActivityFeatureEdit" })(ActivityFeatureEdit);
